import { RouteType } from "types/RouteType";

const ProductionScheduleUploadRoute: RouteType = {
  name: "Production Schedule CSV Upload",
  path: "/production/production-schedule-upload",
  layout: "/app",
  group: "Production",
  viewportCard: {
    header: {
      component: () => import("./ProductionScheduleUploadHeader"),
      title: "Production Schedule Upload",
      enableRefreshButton: false,
    },
    body: {
      component: () => import("./ProductionScheduleUploadBody"),
      grayBackground: true,
    },
  },
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  dialogs: [
    {
      name: "ProductionScheduleUploadDialog",
      component: () => import("./ProductionScheduleUploadDialog"),
      title: "Upload Production Schedule CSV",
      cancelButton: true,
      height: 600,
      fullWidth: true,
    },
  ],
  beforeEnter: async ({ rootStore }: any) => {
    try {
      // Load projects for selection dropdown
      if (rootStore.projectsStore) {
        await rootStore.projectsStore.find();
      }

      // Load existing molds for reference
      if (rootStore.moldsStore) {
        await rootStore.moldsStore.find();
      }

      // Load production schedule store for scheduling
      if (rootStore.productionScheduleStore) {
        await rootStore.productionScheduleStore.find();
      }

      return true;
    } catch (error) {
      console.error("[ProductionScheduleUpload Route] Error loading data:", error);
      return true;
    }
  },
};

export default ProductionScheduleUploadRoute;
